import { render, staticRenderFns } from "./FileCheck2Icon.vue?vue&type=template&id=051b80f0"
import script from "./FileCheck2Icon.vue?vue&type=script&lang=js"
export * from "./FileCheck2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports